import { useField } from 'informed';
import PropTypes from 'prop-types';
import { Fragment } from 'react';

import './styles/formFieldStyles.css';

const SelectField = ({ children, ...props }) => {
  const { fieldApi, fieldState, informed, render, userProps } = useField(props);
  const { onBlur, onChange } = userProps;
  const { error, touched, value } = fieldState;
  const { setTouched, setValue } = fieldApi;
  const statusClass =
    value && !error && touched ? 'success' : value && error && 'error';

  return render(
    <Fragment>
      <select
        {...informed}
        {...userProps}
        aria-invalid={!!error}
        className={`custom-field ${statusClass || ''}`}
        id={props.id || props.field}
        onBlur={(e) => {
          setTouched(true);
          if (onBlur) {
            onBlur(e);
          }
        }}
        onChange={(e) => {
          setValue(e.target.value);
          if (onChange) {
            onChange(e);
          }
        }}
      >
        {children}
      </select>
      {error && <small className="text-red-3">{error}</small>}
    </Fragment>,
  );
};

SelectField.propTypes = {
  children: PropTypes.node.isRequired,
};

export default SelectField;
